import React from 'react';
import { Snackbar, Alert } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';
import { clearSnackbar } from 'app/redux/slices/snackbarSlice';

const AgyleSnackbar = () => {
  const snackbar = useSelector((state) => state.snackbar);
  const dispatch = useDispatch();
  const handleCloseSnackbar = () => {
    dispatch(clearSnackbar());
  };

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={6000}
      onClose={handleCloseSnackbar}
    >
      <Alert
        onClose={handleCloseSnackbar}
        severity={snackbar.status}
        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <span>{snackbar.message}</span>
        {snackbar.link && (
          <a
            href={snackbar.link}
            style={{
              color: 'inherit',
              marginLeft: 8,
              fontWeight: 600,
              textDecoration: 'underline',
            }}
          >
            {snackbar.linkText || 'View'}
          </a>
        )}
      </Alert>
    </Snackbar>
  );
};
export default AgyleSnackbar;
